<div class="ir-area ir-mask th-mask" [open]="!isOpen" [attr.data-keyboard]="true" [attr.data-backdrop]="false">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ title }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2 class="th-txt" [ngClass]="{ 'ir-position--m ir-txt--big modal': center }">
          <div class="ir-modal-loaded-icon" *ngIf="loadedIcon || warningIcon">
            <i *ngIf="warningIcon" class="material-icons warning">offline_pin</i>
            <i *ngIf="!warningIcon" class="material-icons offline">offline_pin</i>
          </div>
          <div class="ir-modal-load-spinner-container" *ngIf="loadSpinner">
            <div class="ir-load-spinner">
              <div class="rect rect1"></div>
              <div class="rect rect2"></div>
              <div class="rect rect3"></div>
              <div class="rect rect4"></div>
              <div class="rect rect5"></div>
            </div>
          </div>
          <span innerHtml="{{ message }}"></span>
        </h2>
      </div>
      <div #child></div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer" *ngIf="modalFooter">
      <div class="ir-row">
        <div class="ir-cell-lar12" (click)="submit()">
          <button
            class="ir-btn ir-btn--big ir-btn--block ir-txt--center"
            [ngClass]="danger ? 'th-btn-remove' : 'th-btn-modal--action'"
          >
            <span>{{ okButtonText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
